import { HttpClient } from '@angular/common/http';

import { VdoApiUser, VdoApiUserV2 } from '../models/vdo-user.model';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VdoUserAuthService {
  constructor(private http: HttpClient) {}

  public loadUserProfile(): Observable<VdoApiUserV2> {
    const url = environment.vdofleet.baseApiUrl + '/id/v2/users/current';
    return this.http.get<VdoApiUserV2>(url);
  }
}
